import React, {useState} from "react";
import {NavLink} from "react-router-dom";
import ContentBox from "../../../../../../components/content-box/ContentBox";
import PageActions from "../../../../../base/PageActions";
import Breadcrumbs from "../../../../../../components/breadcrumbs/Breadcrumbs";
import Modal from "../../../../../../components/modal/Modal";
import _image_service from "../../../../../../services/ImageService";
import '../../../../../styles/Common.scss';
import '../../WorldPages.scss';
import '../../WorldDynamicContent.scss';

interface RebellionHistoryPageProps {
}

const RebellionHistoryPage = (props: RebellionHistoryPageProps) => {

    const _map_src = `chase/world/geography/casarok_pre_cataclysm.png`;

    const page: PageActions = new PageActions({
        title: `Casarok History: Rebellion Age - Chase the Fox`,
        description: "The Rebellion Age of Casarok covers the time when the Anthro race earned their freedom in the world!",
        keywords: ["casarok", "casarok history", "rebellion age", "fantasy timeline", "fantasy world history"],
        imgSrc: _map_src,
        url: `world/history/rebellion-age`
    });

    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);

    return page.generateMetaContent(
        <>
            <Modal isOpen={modalIsOpen}
                   onClose={() => setModalIsOpen(false)}>
                <div className="geography-modal-view">
                    <p className="center">
                        <a href={_image_service.getCdnImageSrc(_map_src, 'full')}
                           target="_blank"
                           rel="noopener noreferrer">
                            Click here to view the full size image.
                        </a>
                    </p>
                    <img src={_image_service.getCdnImageSrc(_map_src, 'desktop')}
                         title='Casarok Pre-Cataclysm Map'
                         alt="A map of Casarok before the Great Cataclysm"/>
                </div>
            </Modal>
            <ContentBox header="The Rebellion Age of Casarok">
                <Breadcrumbs path={page.getUrl()}/>
                <div className="world-page-static">
                    <a id="visible-element"
                       className="switch-visible geography-modal-link"
                       onClick={() => setModalIsOpen(true)}>
                        <img className="block width-50-percent"
                             src={_image_service.getCdnImageSrc(`chase/world/geography/casarok_pre_cataclysm.png`)}
                             title='Casarok Pre-Cataclysm Map'
                             alt="A map of Casarok before the Great Cataclysm"/>
                    </a>
                </div>
                <div className="world-page-static">
                    <p className="center">
                        <em>This age covers the years of roughly 3,000 - 1,500 BCE.</em>
                    </p>
                    <p>
                        The Rebellion Age covers the time period during which
                        the <NavLink className="world-link" to="/world/bestiary/anthro">Anthro</NavLink> race began to
                        become free from the subjugation of the other races. The outcome was self-fulfilling: While the
                        populations of the more powerful races dwindled or remained relatively stable, they also caused
                        the Anthro numbers to explode. The free Anthro settlements throughout the world noticed this
                        fact and led the way to freeing their brethren. The more of their peoples they freed, the more
                        their numbers increased. Over the time of this age, the Anthro race became the largest and
                        arguably most powerful of the three.
                    </p>
                    <p>
                        Part of the Anthro race's success is attributed to their learning of early magic. Unlike the
                        other races which are locked into sets of magic in their own ways, Anthros can learn any type of
                        magic. Their flexibility in spellcasting became their greatest strength. Meanwhile,
                        the <NavLink className="world-link" to="/world/bestiary/draconic/dracamma">dracammas</NavLink> maintained
                        much of their lands and remained one of the most powerful species in the world. Otherwise,
                        many ancient civilizations and empires began to fall during this time.
                    </p>
                    <p>
                        <em>How does Casarok's Rebellion Age differ from the early antiquity era on Earth?</em><br/>
                        Many oppressed peoples became freed through their use of magic, perhaps through the aid of
                        the <NavLink className="world-link" to="/world/religion/pantheon">Casarok pantheon</NavLink>. One
                        race became clearly dominant throughout the world as opposed to Earth in which the various
                        regions still had their own dominant ethnicities and powers.
                    </p>
                    <h3 className="headline">Notable Events (in order of their occurrence)</h3>
                    <ul className="spaced">
                        <li>
                            The free Anthro settlements begin seeking help from the gods and goddesses of Casarok for
                            assistance with their enslaved brethren.
                        </li>
                        <li>
                            Free Anthros begin to learn basic magic.
                        </li>
                        <li>
                            While territorial disputes continue to occur among the more powerful races, missions are led
                            to free more Anthros from their oppressors.
                        </li>
                        <li>
                            Some of the smaller economic powers fall to those with more power and experience in war.
                        </li>
                        <li>
                            Anthro settlements grow into their own nations.
                        </li>
                    </ul>
                </div>
            </ContentBox>
        </>
    );
}

export default RebellionHistoryPage;